<span class="status-badge" [class]="'status-badge ' + statusClass">{{ statusKey | translate }}</span>
